import { BROKERBANS_PAY } from './types';
// eslint-disable-next-line import/prefer-default-export
export var setBrokerBansPayRedux = function (payload) { return ({
    type: BROKERBANS_PAY,
    payload: payload,
}); };
